import React, { useState } from "react";
import { deleteApi, postApi, putApi } from "../AppApis";
import { toast } from "react-toastify";

export default function DeleteImageModal({
    onClose,
    selectedImage,
    handleDelete,
    isDeleteModalShow,
    property,
    setShowModal,
    setImageFiles,
    fetchProperties,
    setSelectedImage,
}) {
    const [isLoading, setIsLoading] = useState(false);
    const DeleteOneImage = async () => {
        if (selectedImage.previewUrl) {
            setImageFiles((prevImageFiles) => prevImageFiles.filter((img) => img.previewUrl !== selectedImage.previewUrl));
            onClose();
            setShowModal(null);
            return;
        }

        let imageUrl = selectedImage.MediaKey;
        const payload = {
            property_id: property.property_id,
            images: [{ MediaKey: imageUrl }],
        };
        const response = await deleteApi("/properties/remove_property_images", payload);
        toast.success("Image deleted successfully.", { toastId: "success" });
        // refresh the page here
        setImageFiles((prevImageFiles) => prevImageFiles.filter((img) => img.MediaKey !== selectedImage.MediaKey));
        onClose();
        setSelectedImage(null);
    };
    const onDelete = async () => {
        if (selectedImage) {
            return DeleteOneImage();
        }
        if (isDeleteModalShow !== "property") {
            handleDelete();
        } else {
            if (isLoading) return;
            setIsLoading(true);
            const formData = new FormData();
            formData.append("is_active", false);
            const response = await postApi(`/properties/${property.property_id}/cancel`);
            console.log("response", response);
            if (response.error) {
                toast.error("Something went wrong. Please try again.");
                return;
            }
            toast.success("Your listing cancelled successfully.");
            // refresh the page here
            fetchProperties();
            setShowModal(null);
            onClose();
            setIsLoading(false);
        }
    };

    const title = isDeleteModalShow !== "property" ? "Delete Image" : "Cancel Listing";
    const description =
        isDeleteModalShow !== "property"
            ? "Are you sure do you want to delete the image?"
            : "Are you sure do you want to cancel the listing? Your Property will be deleted completely.";

    return (
        <div style={{ zIndex: 9999999 }} className="tw-fixed tw-inset-0 tw-flex tw-justify-center tw-items-center tw-bg-black/50">
            <div className="tw-bg-white tw-rounded-md tw-p-5 tw-w-[90vw] md:tw-w-[600px] tw-max-h-[90vh] tw-overflow-y-auto">
                <p className="tw-text-[700] tw-text-[25px] tw-text-black tw-text-center">{title}</p>
                <p className="tw-text-black tw-text-center">{description} </p>
                <div className="tw-flex tw-mt-5 tw-justify-center tw-items-center tw-gap-3">
                    <button onClick={onClose} className="tw-border tw-border-border_color tw-px-4 tw-py-1 tw-rounded-md tw-text-black">
                        Cancel
                    </button>
                    <button onClick={onDelete} className="tw-bg-[red] tw-rounded-md tw-px-4 tw-py-1 tw-text-white">
                        {isLoading ? "Cancelling..." : "Yes"}
                    </button>
                </div>
            </div>
        </div>
    );
}
